import api from "./axios";

export const commentApi = {

    // DELETE COMMENT
    deleteComment: async (commentId) => {
        const res = await api.delete(`/comments/comment/${commentId}`);
        return res.data;
    },

};